module.exports = __webpack_public_path__ + "static/media/declinado.8ceb5dbf.svg";